/*! @pentacode/ui v0.1.0 */
//#region \0@oxc-project+runtime@0.152.0/helpers/esm/decorateMetadata.js
function e(e, t) {
	if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
//#endregion
export { e as t };
